module.exports = __webpack_public_path__ + "media/images/icons/icon-expand-38c077813090bd1257f5fde33c76930d.svg";